import { render, staticRenderFns } from "./month-slider.vue?vue&type=template&id=36508d0a&scoped=true&"
import script from "./month-slider.vue?vue&type=script&lang=js&"
export * from "./month-slider.vue?vue&type=script&lang=js&"
import style0 from "./month-slider.vue?vue&type=style&index=0&id=36508d0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36508d0a",
  null
  
)

component.options.__file = "month-slider.vue"
export default component.exports